import { createStore } from 'vuex'

export default createStore({
  state: {
    simInfo: { code: 'ok' },
    isQueriedSim: false,
    language: '',
    redeemResult: {}
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
